import { axiosConfig } from '../config/application/axios';
import * as landing from './landing';

const packages = {
  landing
};

function axios() {
  return axiosConfig.getAxiosInstance();
}

function createRequest(request) {
  return params => {
    const config = request(params);
    const instanceAxios = axios();
    return instanceAxios(config);
  };
}

function createMethods(reqRespObj) {
  const methods = {};
  Object.keys(reqRespObj).forEach(methodName => {
    methods[methodName] = createRequest(reqRespObj[methodName]);
  });
  return methods;
}

function wrapAllByCreateMethods(obj) {
  const ret = {};
  Object.keys(obj).forEach(packageName => {
    ret[packageName] = createMethods(obj[packageName]);
  });
  return ret;
}

/**
 * @type {Object} api
 * @property {Object} landing
 */
export default wrapAllByCreateMethods(packages);
